export function setLocalStorage(key: string, obj: any) {
  if (obj === null || obj === undefined) {
    return localStorage.removeItem(key);
  }
  if (typeof obj === "string") {
    return localStorage.setItem(key, obj);
  }
  localStorage.setItem(key, JSON.stringify(obj));
}

export function getLocalStorage(key: string): any | null {
  const obj = localStorage.getItem(key);
  if (obj === undefined || obj === null) return null;
  else if (typeof obj === "string") return obj;
}

export function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}
